var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        scrollable: ""
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [
              _vm._v(
                " Edit an " +
                  _vm._s(_vm.typeSelect) +
                  " record for " +
                  _vm._s(_vm.item.domain) +
                  " "
              )
            ]
          ),
          _c(
            "gg-card-text",
            [
              _c("gg-input-label", [_vm._v("Record Type")]),
              _c("v-select", {
                staticClass: "gg-input",
                attrs: {
                  outlined: "",
                  dense: "",
                  items: _vm.types
                },
                model: {
                  value: _vm.typeSelect,
                  callback: function callback($$v) {
                    _vm.typeSelect = $$v
                  },
                  expression: "typeSelect"
                }
              }),
              _vm.typeSelect === "A"
                ? _c("a-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "AAAA"
                ? _c("a-a-a-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "CNAME"
                ? _c("c-name-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "CAA"
                ? _c("c-a-a-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "SRV"
                ? _c("s-r-v-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "TXT"
                ? _c("t-x-t-record-form", {
                    attrs: {
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "MX"
                ? _c("m-x-record-form", {
                    attrs: {
                      domain: _vm.item.domain,
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.typeSelect === "DMARC"
                ? _c("d-m-a-r-k-record-form", {
                    attrs: {
                      domain: _vm.item.domain,
                      item: _vm.item,
                      edit: ""
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.editRecord
                  }
                },
                [_vm._v(" Update ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }